var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.dataList),function(row,ids){return _c('media',{key:ids,attrs:{"option":row}})}),_c('page',{staticClass:"pagination",attrs:{"total":_vm.tablePage.total,"page":_vm.tablePage.currentPage},on:{"currentPage":_vm.currentPage}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }